import React from 'react'
import styled from 'styled-components'
import MessageBoxFunctionalLayout from 'wix-style-react/src/MessageBox/MessageBoxFunctionalLayout'
import { media } from 'components/styles'

const Wrapper = styled.div`
  ${media.small`font-size: 12px;`}
  ${media.normal`font-size: 15px;`}
  ${media.huge`font-size: 24px;`}
  > div {
    ${media.small`font-size: 12px;`}
    ${media.normal`font-size: 15px;`}
    ${media.huge`font-size: 24px;`}
  }
`
const ContentContainer = styled.div`
  ${media.small`font-size: 12px;`}
  ${media.normal`font-size: 15px;`}
  ${media.huge`font-size: 24px;`}
`
const MBFL = (props) => {
  return (
    <Wrapper>
      <MessageBoxFunctionalLayout {...props}>
        <ContentContainer>
          {props.children}
        </ContentContainer>
      </MessageBoxFunctionalLayout>
    </Wrapper>
  )
}

export default MBFL



// WEBPACK FOOTER //
// ./src/components/shared/MessageBoxFunctionalLayout.js